"use client"

import { useState, useEffect } from "react"
import { FiPlus, FiEdit, FiCheck, FiBriefcase, FiCalendar, FiClock, FiFolder } from "react-icons/fi"
import { getCase } from "@/services/Users/getCase"
import { getUserRole } from "@/services/Auth/loginService"
import { getAccountData, userData } from "@/context/getAccountData" // Importar userData
import { createCase } from "@/services/Users/createCase"
import Swal from "sweetalert2";
// Case management view component
function CasesView({ onOpenCase }) {
  const [cases, setCases] = useState([])
  const [showNewCaseForm, setShowNewCaseForm] = useState(false)
  const [showEditCaseForm, setShowEditCaseForm] = useState(false)
  const [editingCase, setEditingCase] = useState(null)
  const [showFolderView, setShowFolderView] = useState(false)
  const [organizationsID, setOrganizationsID] = useState("")
  const [newCase, setNewCase] = useState({
    id: "",
    name: "",
    type: "Mercantil",
    client: "",
    description: "",
    startDate: "",
    status: "Procesando",
    createdAt: "",
    organizationEmail: "", // Campo para el email de la organización como alternativa
  })
  const [clients, setClients] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [filterType, setFilterType] = useState("all")
  const [filterStatus, setFilterStatus] = useState("all")
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  // Añadir nuevos estados para los modales de confirmación y advertencia
  const [showFinishConfirmation, setShowFinishConfirmation] = useState(false)
  const [caseToFinish, setCaseToFinish] = useState(null)
  const [showEditBlockedModal, setShowEditBlockedModal] = useState(false)

  // Status options
  const statusOptions = ["Procesando", "En progreso", "Completado", "Cancelado"]

  // Status colors
  const statusColors = {
    Procesando: "bg-yellow-100 text-yellow-800",
    "En progreso": "bg-blue-100 text-blue-800",
    Completado: "bg-yellow-100 text-gold-800",
    Cancelado: "bg-yellow-100 text-red-800",
    Finalizado: "bg-green-100 text-green-800",
    // Mapeo de estados del backend
    Processing: "bg-yellow-100 text-yellow-800",
    "In Progress": "bg-blue-100 text-blue-800",
    Completed: "bg-yellow-100 text-gold-800",
    Cancelled: "bg-yellow-100 text-red-800",
    Finished: "bg-green-100 text-green-800",
  }

  // Obtener el ID de la organización usando userData
  useEffect(() => {
    try {
      const userDataInfo = userData()
      console.log("userData:", userDataInfo)
      if (userDataInfo && userDataInfo.organization_id) {
        setOrganizationsID(userDataInfo.organization_id)
      }
    } catch (error) {
      console.error("Error al obtener userData:", error)
    }
  }, [])

  // Load cases and clients from localStorage on component mount
  useEffect(() => {
    const savedCases = localStorage.getItem("legalCases")
    if (savedCases) {
      try {
        setCases(JSON.parse(savedCases))
      } catch (e) {
        console.error("Error parsing saved cases:", e)
      }
    }
    // Load or create sample clients
    const savedClients = localStorage.getItem("legalClients")
    if (savedClients) {
      try {
        setClients(JSON.parse(savedClients))
      } catch (e) {
        console.error("Error parsing saved clients:", e)
      }
    } else {
      // Create sample clients if none exist
      const sampleClients = [
        { id: "client-1", name: "Empresa XYZ", email: "contacto@xyz.com", phone: "555-1234" },
        { id: "client-2", name: "Corporación 123", email: "legal@corp123.com", phone: "555-5678" },
        { id: "client-3", name: "Industrias ABC", email: "info@iabc.com", phone: "555-9012" },
        { id: "client-4", name: "Comercial MNO", email: "legal@mno.com", phone: "555-3456" },
      ]
      setClients(sampleClients)
      localStorage.setItem("legalClients", JSON.stringify(sampleClients))
    }
  }, [])

  // Save cases to localStorage when they change
  useEffect(() => {
    if (cases.length > 0) {
      localStorage.setItem("legalCases", JSON.stringify(cases))
    }
  }, [cases])

  // Modificar la función handleCreateCase para usar la API createCase
  const handleCreateCase = async () => {
    if (!newCase.name || !newCase.client) {
      alert("Por favor complete al menos el nombre del caso y seleccione un cliente.")
      return
    }

    // Verificar si tenemos el ID de la organización o el email
    if (!organizationsID && !newCase.organizationEmail) {
      alert("Por favor ingrese el email de la organización ya que no se pudo obtener el ID automáticamente.")
      return
    }

    try {
      setLoading(true)

      // Preparar los datos para la API según el formato requerido
      const caseData = {
        organization_id: organizationsID || "", // Usar el ID de la organización del usuario
        title: newCase.name,
        description: newCase.description,
        client: newCase.client, // Esto debería ser el correo del cliente
        service_type: newCase.type,
      }

      // Si no hay organization_id pero sí hay email, usamos el email
      if (!organizationsID && newCase.organizationEmail) {
        caseData.organization_email = newCase.organizationEmail
      }

      // Añadir fecha de inicio si existe
      if (newCase.startDate) {
        caseData.start_date = new Date(newCase.startDate).toISOString()
      }

      console.log("Enviando datos para crear caso:", caseData)

      // Llamar a la API para crear el caso
      const response = await createCase(caseData)
      console.log("Response from createCase:", response)
      
      Swal.fire({
        icon: 'success',
        title: 'Caso creado',
        text: 'El caso se ha creado correctamente.',
        showConfirmButton: false,
        timer: 1500
      })
      


      // Actualizar la lista de casos
      const idUser = getAccountData()._id
      const role = getUserRole().toLowerCase()
      const rutaUser = `${role}=${idUser}`
      const casesResponse = await getCase(rutaUser)
      const mappedCases = mapBackendCases(casesResponse)
      setCases(mappedCases)

      // Limpiar el formulario
      setNewCase({
        id: "",
        name: "",
        type: "Mercantil",
        client: "",
        description: "",
        startDate: "",
        status: "Procesando",
        createdAt: "",
        organizationEmail: "",
      })

      setShowNewCaseForm(false)
      setError(null)
    } catch (error) {
      console.error("Error al crear el caso:", error)
      Swal.fire({
        icon: 'error',
        title: 'Error al crear el caso',
        text: 'Ha ocurrido un error al crear el caso. Por favor, intente de nuevo.',
        showConfirmButton: false,
        timer: 1500
      })
    } finally {
      setLoading(false)
    }
  }

  // Handle editing a case
  const handleEditCase = () => {
    if (!editingCase.name || !editingCase.client) {
      alert("Por favor complete al menos el nombre del caso y seleccione un cliente.")
      return
    }

    setCases((prevCases) => prevCases.map((c) => (c.id === editingCase.id ? editingCase : c)))

    setEditingCase(null)
    setShowEditCaseForm(false)
  }

  // Modificar la función startEditingCase para verificar si el caso está finalizado
  const startEditingCase = (caseItem) => {
    if (caseItem.status === "Finalizado" || caseItem.state === "Finished") {
      setShowEditBlockedModal(true)
      return
    }

    setEditingCase({ ...caseItem })
    setShowEditCaseForm(true)
  }

  // Modificar la función handleMarkAsFinished para usar el modal en lugar de window.confirm
  const handleMarkAsFinished = (caseId) => {
    const caseItem = cases.find((c) => c.id === caseId || c._id === caseId)
    setCaseToFinish(caseItem)
    setShowFinishConfirmation(true)
  }

  // Añadir función para confirmar finalización
  const confirmFinishCase = () => {
    if (caseToFinish) {
      setCases((prevCases) =>
        prevCases.map((c) => {
          if (c.id === caseToFinish.id || c._id === caseToFinish._id) {
            return { ...c, status: "Finalizado", state: "Finished" }
          }
          return c
        }),
      )
      setShowFinishConfirmation(false)
      setCaseToFinish(null)
    }
  }

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "No especificado"

    try {
      const date = new Date(dateString)
      return date.toLocaleString("es-ES", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    } catch (e) {
      return dateString
    }
  }

  // Función para mapear los datos del backend al formato esperado por el componente
  const mapBackendCases = (backendData) => {
    if (!backendData) return []

    // Si la respuesta tiene la estructura esperada con "list"
    if (backendData.list && Array.isArray(backendData.list)) {
      return backendData.list.map((item) => ({
        id: item._id,
        _id: item._id,
        name: item.title,
        title: item.title,
        type: item.service_type,
        service_type: item.service_type,
        client: item.client, // Aquí podríamos buscar el nombre del cliente si tenemos una lista
        description: item.description,
        startDate: item.start_date,
        start_date: item.start_date,
        status: mapStateToStatus(item.state),
        state: item.state,
        createdAt: item.CreatedAt,
        CreatedAt: item.CreatedAt,
        documents: item.documents || [],
      }))
    }

    // Si ya es un array de casos
    if (Array.isArray(backendData)) {
      return backendData.map((item) => ({
        id: item._id,
        _id: item._id,
        name: item.title,
        title: item.title,
        type: item.service_type,
        service_type: item.service_type,
        client: item.client, // Aquí podríamos buscar el nombre del cliente si tenemos una lista
        description: item.description,
        startDate: item.start_date,
        start_date: item.start_date,
        status: mapStateToStatus(item.state),
        state: item.state,
        createdAt: item.CreatedAt,
        CreatedAt: item.CreatedAt,
        documents: item.documents || [],
      }))
    }

    return []
  }

  // Función para mapear los estados del backend a los estados del componente
  const mapStateToStatus = (state) => {
    const stateMap = {
      Processing: "Procesando",
      "In Progress": "En progreso",
      Completed: "Completado",
      Cancelled: "Cancelado",
      Finished: "Finalizado",
    }
    return stateMap[state] || state
  }

  useEffect(() => {
    async function fetchCases() {
      try {
        setLoading(true)
        const idUser = getAccountData()._id
        const role = getUserRole().toLowerCase()
        const rutaUser = `${role}=${idUser}`
        const response = await getCase(rutaUser)
        console.log("Fetched cases:", response)

        // Mapear los datos del backend al formato esperado por el componente
        const mappedCases = mapBackendCases(response)
        setCases(mappedCases)
        setError(null)
      } catch (error) {
        console.error("Error fetching cases:", error)
        setError("No se pudieron cargar los casos. Por favor, intente de nuevo más tarde.")
        setCases([]) // Establecer un array vacío en caso de error
      } finally {
        setLoading(false)
      }
    }
    fetchCases()
  }, [])

  // Filter cases based on search term, type filter and status filter
  const filteredCases = Array.isArray(cases)
    ? cases.filter((c) => {
        const matchesSearch =
          c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          c.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          c.client?.toLowerCase().includes(searchTerm.toLowerCase())
        const matchesType = filterType === "all" || c.type === filterType || c.service_type === filterType
        const matchesStatus = filterStatus === "all" || c.status === filterStatus || c.state === filterStatus
        return matchesSearch && matchesType && matchesStatus
      })
    : []

  return (
    <div className="max-w-[1400px] mx-auto p-6 h-full w-full px-4">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-[#1A365D]">Gestión de Casos</h2>
        <div className="flex gap-2">
          <button
            onClick={() => {
              setLoading(true)
              const idUser = getAccountData()._id
              const role = getUserRole().toLowerCase()
              const rutaUser = `${role}=${idUser}`
              getCase(rutaUser)
                .then((response) => {
                  const mappedCases = mapBackendCases(response)
                  setCases(mappedCases)
                  setError(null)
                })
                .catch((err) => {
                  console.error("Error refreshing cases:", err)
                  setError("Error al actualizar los casos")
                  setCases([]) // Establecer un array vacío en caso de error
                })
                .finally(() => setLoading(false))
            }}
            className="px-4 py-2 bg-white border border-[#1A365D] text-[#1A365D] rounded hover:bg-gray-50 flex items-center"
            disabled={loading}
          >
            <svg
              className="w-4 h-4 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            Actualizar
          </button>
          <button
            onClick={() => setShowNewCaseForm(true)}
            className="px-4 py-2 bg-[#1A365D] text-white rounded hover:bg-opacity-90 flex items-center"
          >
            <FiPlus className="mr-1" /> Nuevo Caso
          </button>
        </div>
      </div>

      {/* Filters and search */}
      <div className="mb-6 flex flex-col md:flex-row gap-4">
        <div className="flex-1">
          <input
            type="text"
            placeholder="Buscar por nombre o cliente..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-2 border rounded"
          />
        </div>
        <div className="flex gap-2">
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            className="px-4 py-2 border rounded"
          >
            <option value="all">Todos los tipos</option>
            <option value="Mercantil">Mercantil</option>
            <option value="Litigios y resolución de conflictos mercantiles">Litigios mercantiles</option>
          </select>

          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="px-4 py-2 border rounded"
          >
            <option value="all">Todos los estados</option>
            {statusOptions.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Loading and error states */}
      {loading && (
        <div className="col-span-full text-center py-12 bg-white rounded-lg shadow">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-[#1A365D] border-r-transparent"></div>
          <p className="mt-2 text-gray-600">Cargando casos...</p>
        </div>
      )}

      {error && (
        <div className="col-span-full text-center py-12 bg-white rounded-lg shadow border border-red-200">
          <p className="text-red-600">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-2 px-4 py-2 bg-[#1A365D] text-white rounded hover:bg-opacity-90"
          >
            Reintentar
          </button>
        </div>
      )}

      {/* Case cards */}
      {!loading && !error && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredCases.map((caseItem) => (
            <div key={caseItem.id || caseItem._id} className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="bg-[#1A365D] text-white p-4">
                <div className="flex justify-between items-start">
                  <h3 className="font-bold text-lg truncate">{caseItem.name || caseItem.title}</h3>
                  <span className={`text-xs px-2 py-1 rounded-full ${statusColors[caseItem.status || caseItem.state]}`}>
                    {caseItem.status || mapStateToStatus(caseItem.state)}
                  </span>
                </div>
                <p className="text-sm opacity-90">Cliente: {caseItem.client}</p>
              </div>
              <div className="p-4">
                <div className="mb-4 space-y-2">
                  <div className="flex items-center text-sm">
                    <FiBriefcase className="mr-2 text-[#B8860B]" />
                    <span>Tipo: {caseItem.type || caseItem.service_type}</span>
                  </div>
                  <div className="flex items-center text-sm">
                    <FiCalendar className="mr-2 text-[#B8860B]" />
                    <span>Inicio: {formatDate(caseItem.startDate || caseItem.start_date)}</span>
                  </div>
                  <div className="flex items-center text-sm">
                    <FiClock className="mr-2 text-[#B8860B]" />
                    <span>Creado: {formatDate(caseItem.createdAt || caseItem.CreatedAt)}</span>
                  </div>
                </div>
                <p className="text-sm text-gray-600 mb-4 line-clamp-2">{caseItem.description || "Sin descripción"}</p>
                <div className="flex justify-between mt-4">
                  <button
                    onClick={(e) => {
                      e.preventDefault()
                      setShowFolderView(true)
                      onOpenCase(caseItem)
                    }}
                    className="px-4 py-2 bg-[#B8860B] text-white rounded hover:bg-opacity-90 flex items-center"
                  >
                    <FiFolder className="mr-1" /> Abrir Carpetas
                  </button>
                  <div className="flex gap-2">
                    <button
                      onClick={() => startEditingCase(caseItem)}
                      className={`p-2 ${caseItem.status === "Finalizado" || caseItem.state === "Finished" ? "text-gray-400 cursor-not-allowed" : "text-blue-500 hover:bg-blue-50"} rounded`}
                    >
                      <FiEdit />
                    </button>
                    {caseItem.status !== "Finalizado" && caseItem.state !== "Finished" && (
                      <button
                        onClick={() => handleMarkAsFinished(caseItem.id || caseItem._id)}
                        className="p-2 text-red-500 hover:bg-red-50 rounded"
                        title="Marcar como finalizado"
                      >
                        <FiCheck />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}

          {filteredCases.length === 0 && (
            <div className="col-span-full text-center py-12 text-gray-500 bg-white rounded-lg shadow">
              No se encontraron casos. Cree un nuevo caso para comenzar.
            </div>
          )}
        </div>
      )}

      {/* New case modal */}
      {showNewCaseForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-xl font-bold mb-4 text-[#1A365D]">Nuevo Caso</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">Nombre del Caso</label>
                <input
                  type="text"
                  value={newCase.name}
                  onChange={(e) => setNewCase({ ...newCase, name: e.target.value })}
                  className="w-full px-3 py-2 border rounded"
                  placeholder="Nombre del caso"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Tipo de Servicio</label>
                <select
                  value={newCase.type}
                  onChange={(e) => setNewCase({ ...newCase, type: e.target.value })}
                  className="w-full px-3 py-2 border rounded"
                >
                  <option value="Mercantil">Mercantil</option>
                  <option value="Litigios y resolución de conflictos mercantiles">Litigios mercantiles</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Cliente (Email)</label>
                <input
                  type="email"
                  value={newCase.client}
                  onChange={(e) => setNewCase({ ...newCase, client: e.target.value })}
                  className="w-full px-3 py-2 border rounded"
                  placeholder="correo@cliente.com"
                />
              </div>

              {/* Mostrar el ID de la organización si existe */}
              {organizationsID ? (
                <div>
                  <label className="block text-sm font-medium mb-1">ID de Organización</label>
                  <input
                    type="text"
                    value={organizationsID}
                    className="w-full px-3 py-2 border rounded bg-gray-50"
                    disabled
                  />
                </div>
              ) : (
                <div>
                  <label className="block text-sm font-medium mb-1">Email de Organización</label>
                  <input
                    type="email"
                    value={newCase.organizationEmail}
                    onChange={(e) => setNewCase({ ...newCase, organizationEmail: e.target.value })}
                    className="w-full px-3 py-2 border rounded"
                    placeholder="No se detectó ID de organización. Ingrese el email."
                  />
                </div>
              )}

              <div>
                <label className="block text-sm font-medium mb-1">Descripción</label>
                <textarea
                  value={newCase.description}
                  onChange={(e) => setNewCase({ ...newCase, description: e.target.value })}
                  className="w-full px-3 py-2 border rounded"
                  rows="3"
                  placeholder="Descripción del caso"
                ></textarea>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Fecha de Inicio</label>
                <input
                  type="date"
                  value={newCase.startDate}
                  onChange={(e) => setNewCase({ ...newCase, startDate: e.target.value })}
                  className="w-full px-3 py-2 border rounded"
                />
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-6">
              <button
                onClick={() => setShowNewCaseForm(false)}
                className="px-4 py-2 border rounded text-gray-700 hover:bg-gray-100"
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                onClick={handleCreateCase}
                className="px-4 py-2 bg-[#1A365D] text-white rounded hover:bg-opacity-90 flex items-center"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="h-4 w-4 mr-2 animate-spin rounded-full border-2 border-solid border-white border-r-transparent"></div>
                    Creando...
                  </>
                ) : (
                  <>Crear Caso</>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit case modal */}
      {showEditCaseForm && editingCase && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-xl font-bold mb-4 text-[#1A365D]">Editar Caso</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">Nombre del Caso</label>
                <input
                  type="text"
                  value={editingCase.name || editingCase.title}
                  onChange={(e) =>
                    setEditingCase({
                      ...editingCase,
                      name: e.target.value,
                      title: e.target.value,
                    })
                  }
                  className="w-full px-3 py-2 border rounded"
                  placeholder="Nombre del caso"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Tipo de Servicio</label>
                <select
                  value={editingCase.type || editingCase.service_type}
                  onChange={(e) =>
                    setEditingCase({
                      ...editingCase,
                      type: e.target.value,
                      service_type: e.target.value,
                    })
                  }
                  className="w-full px-3 py-2 border rounded"
                >
                  <option value="Mercantil">Mercantil</option>
                  <option value="Litigios y resolución de conflictos mercantiles">Litigios mercantiles</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Cliente</label>
                <select
                  value={editingCase.client}
                  onChange={(e) => setEditingCase({ ...editingCase, client: e.target.value })}
                  className="w-full px-3 py-2 border rounded"
                >
                  <option value="">Seleccionar cliente</option>
                  {clients.map((client) => (
                    <option key={client.id} value={client.name}>
                      {client.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Estado</label>
                <select
                  value={editingCase.status || mapStateToStatus(editingCase.state)}
                  onChange={(e) =>
                    setEditingCase({
                      ...editingCase,
                      status: e.target.value,
                      state:
                        e.target.value === "Procesando"
                          ? "Processing"
                          : e.target.value === "En progreso"
                            ? "In Progress"
                            : e.target.value === "Completado"
                              ? "Completed"
                              : e.target.value === "Cancelado"
                                ? "Cancelled"
                                : e.target.value === "Finalizado"
                                  ? "Finished"
                                  : e.target.value,
                    })
                  }
                  className="w-full px-3 py-2 border rounded"
                >
                  {statusOptions.map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Descripción</label>
                <textarea
                  value={editingCase.description}
                  onChange={(e) => setEditingCase({ ...editingCase, description: e.target.value })}
                  className="w-full px-3 py-2 border rounded"
                  rows="3"
                  placeholder="Descripción del caso"
                ></textarea>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Fecha de Inicio</label>
                <input
                  type="date"
                  value={editingCase.startDate || editingCase.start_date?.split("T")[0]}
                  onChange={(e) =>
                    setEditingCase({
                      ...editingCase,
                      startDate: e.target.value,
                      start_date: e.target.value,
                    })
                  }
                  className="w-full px-3 py-2 border rounded"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Fecha de Creación</label>
                <input
                  type="text"
                  value={formatDate(editingCase.createdAt || editingCase.CreatedAt)}
                  className="w-full px-3 py-2 border rounded bg-gray-50"
                  disabled
                />
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-6">
              <button
                onClick={() => {
                  setShowEditCaseForm(false)
                  setEditingCase(null)
                }}
                className="px-4 py-2 border rounded text-gray-700 hover:bg-gray-100"
              >
                Cancelar
              </button>
              <button
                onClick={handleEditCase}
                className="px-4 py-2 bg-[#1A365D] text-white rounded hover:bg-opacity-90"
              >
                Guardar Cambios
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modales de confirmación y advertencia */}
      {/* Modal de confirmación para finalizar caso */}
      {showFinishConfirmation && caseToFinish && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-xl font-bold mb-4 text-[#1A365D]">Confirmar acción</h3>
            <p className="mb-6">
              ¿Está seguro que desea marcar el caso{" "}
              <span className="font-bold">{caseToFinish.name || caseToFinish.title}</span> como finalizado?
              <span className="block mt-2 text-red-600 font-medium">Esta acción no se podrá revertir.</span>
            </p>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => {
                  setShowFinishConfirmation(false)
                  setCaseToFinish(null)
                }}
                className="px-4 py-2 border rounded text-gray-700 hover:bg-gray-100"
              >
                Cancelar
              </button>
              <button onClick={confirmFinishCase} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
                Finalizar caso
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de advertencia para edición bloqueada */}
      {showEditBlockedModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-xl font-bold mb-4 text-[#1A365D]">Acción no permitida</h3>
            <p className="mb-6">No es posible editar un caso que ya ha sido finalizado.</p>
            <div className="flex justify-end">
              <button
                onClick={() => setShowEditBlockedModal(false)}
                className="px-4 py-2 bg-[#1A365D] text-white rounded hover:bg-opacity-90"
              >
                Entendido
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CasesView

